var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAmount),expression:"newAmount"}],attrs:{"type":"number","step":"1","max":"5000"},domProps:{"value":(_vm.newAmount)},on:{"blur":_vm.checkAmount,"keyup":_vm.amountChange,"input":function($event){if($event.target.composing){ return; }_vm.newAmount=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6aa83d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputComponent.vue
// module id = 2yAW
// module chunks = 1